"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    right: "auto",
    left: 0,
    bottom: 0,
    width: props => {
      return props.width;
    },
    marginLeft: props => {
      return "-" + props.width + "px";
    },
    transition: ".125s ease-out",
    "&[aria-expanded=true]": {
      [theme.breakpoints.up('sm')]: {
        marginLeft: 0
      }
    },
    "&[aria-expanded=true] + *": {
      [theme.breakpoints.up('sm')]: {
        marginLeft: props => {
          return props.width;
        }
      }
    }
  }
}));

const AppSidebar = ({
  className,
  expanded = true,
  width = 224,
  children
}) => {
  const classes = useStyles({
    width
  });
  return _react.default.createElement("aside", {
    className: className || classes.root,
    "aria-expanded": expanded
  }, children);
};

var _default = AppSidebar;
exports.default = _default;
module.exports = exports.default;